import { render, staticRenderFns } from "./MainCanvas.vue?vue&type=template&id=38c913d5&scoped=true&"
import script from "./MainCanvas.vue?vue&type=script&lang=js&"
export * from "./MainCanvas.vue?vue&type=script&lang=js&"
import style0 from "./MainCanvas.vue?vue&type=style&index=0&id=38c913d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c913d5",
  null
  
)

export default component.exports